import firebase from "firebase";
import React, { useState } from "react";
import MD5 from "crypto-js/md5";
import axios from "axios";
const Oyreg = ({ Oybek }) => {
  const [vin, setVin] = useState("");
  const [version, setVersion] = useState("light");
  const [boxNumber, setBoxNumber] = useState("");
  const [token, setToken] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [seatHeating, setSeatHeating] = useState("1");
  const [seatVentilating, setSeatVentilating] = useState("1");
  const [wheelHeating, setWheelHeating] = useState("yes");
  const [date, setDate] = useState("");
  const handleSubmit = () => {
    const vinHash = MD5(vin).toString();
    const data = {
      vinHash,
      version,
      ...(version === "pro" && { boxNumber, token }),
      date: new Date().toISOString(),
      seatHeating,
      seatVentilating,
      wheelHeating,
      boxNumber: boxNumber || 0,
    };
    firebase
      .database()
      .ref()
      .child("BYDApp")
      .child("registeredVin")
      .child(vinHash)
      .set(data);
    console.log("Submitted:", data);
    if (Oybek) {
      firebase
        .database()
        .ref()
        .child("BYDApp")
        .child("OyReg")
        .push({ vin: vinHash, date: new Date().toISOString() });
    }
    alert("Data submitted, check console for details.");
  };

  const handleSearch = async () => {
    const vinHash = MD5(vin).toString();
    const dataRef = firebase
      .database()
      .ref()
      .child("BYDApp")
      .child("registeredVin")
      .child(vinHash);
    const snapshot = await dataRef.once("value");
    const data = snapshot.val();
    if (data) {
      setVersion(data.version || "light");
      setBoxNumber(data.boxNumber || "");
      setToken(data.token || "");
      setDataFetched(true);
      setDate(data.date);
      setSeatHeating(data.seatHeating);
      setWheelHeating(data.wheelHeating);
      setSeatVentilating(data.seatVentilating);
    } else {
      alert("No data found for this VIN");
      setDataFetched(false);
    }
  };
  const handleLogOut = () => {
    firebase.auth().signOut();
  };
  const regAlive = async () => {
    if (!vin || !token) {
      alert("Missing Data");
      return;
    }
    try {
      const url = `https://us-central1-lusartrans-3fa20.cloudfunctions.net/getAndSetAliveToken`;
      const body = {
        vin: MD5(vin).toString(),
        sim: token,
      };
      const resp = await axios.post(url, body);

      if (resp.status === 200) {
        alert("ok Reged");
      }
    } catch (error) {
      console.error("POST request error:", error);
    }
  };
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f8ff",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <button
        onClick={handleLogOut}
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          backgroundColor: "#28a745",
          color: "white",
          padding: "12px",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "16px",
          width: "100px",
        }}
      >
        Log Out
      </button>

      <div
        style={{
          backgroundColor: "white",
          padding: "30px",
          borderRadius: "12px",
          boxShadow: "0 0 15px rgba(0,0,0,0.1)",
          width: "350px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <h2 style={{ textAlign: "center", margin: 0 }}>Enter VIN Info</h2>

        <input
          type="text"
          placeholder="Enter VIN code"
          value={vin}
          onChange={(e) => setVin(e.target.value)}
          style={{
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
        <input
          type="text"
          placeholder="Enter Sim"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          style={{
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
        <span>{date}</span>

        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <input
              type="radio"
              value="light"
              checked={version === "light"}
              onChange={() => setVersion("light")}
            />
            Light
          </label>
          <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <input
              type="radio"
              value="pro"
              checked={version === "pro"}
              onChange={() => setVersion("pro")}
            />
            Pro
          </label>
        </div>

        {version === "pro" && (
          <>
            <input
              type="text"
              placeholder="Enter box number"
              value={boxNumber}
              onChange={(e) => setBoxNumber(e.target.value)}
              style={{
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
          </>
        )}

        {/* Seat Heating */}
        <div>
          <strong>Seat Heating:</strong>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              marginTop: "5px",
            }}
          >
            <label>
              <input
                type="radio"
                name="seatHeating"
                value={0}
                checked={seatHeating === 0}
                onChange={() => setSeatHeating(0)}
              />
              No seat heating
            </label>
            <label>
              <input
                type="radio"
                name="seatHeating"
                value={1}
                checked={seatHeating === 1}
                onChange={() => setSeatHeating(1)}
              />
              1 row
            </label>
            <label>
              <input
                type="radio"
                name="seatHeating"
                value={2}
                checked={seatHeating === 2}
                onChange={() => setSeatHeating(2)}
              />
              2 rows
            </label>
          </div>
        </div>

        {/* Seat Ventilating */}
        <div>
          <strong>Seat Ventilating:</strong>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              marginTop: "5px",
            }}
          >
            <label>
              <input
                type="radio"
                name="seatVentilating"
                value={0}
                checked={seatVentilating === 0}
                onChange={() => setSeatVentilating(0)}
              />
              No seat ventilating
            </label>
            <label>
              <input
                type="radio"
                name="seatVentilating"
                value={1}
                checked={seatVentilating === 1}
                onChange={() => setSeatVentilating(1)}
              />
              1 row
            </label>
            <label>
              <input
                type="radio"
                name="seatVentilating"
                value={2}
                checked={seatVentilating === 2}
                onChange={() => setSeatVentilating(2)}
              />
              2 rows
            </label>
          </div>
        </div>

        {/* Wheel Heating */}
        <div>
          <strong>Wheel Heating:</strong>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              marginTop: "5px",
            }}
          >
            <label>
              <input
                type="radio"
                name="wheelHeating"
                value={1}
                checked={wheelHeating === 1}
                onChange={() => setWheelHeating(1)}
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="wheelHeating"
                value={0}
                checked={wheelHeating === 0}
                onChange={() => setWheelHeating(0)}
              />
              No
            </label>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            width: "100%",
          }}
        >
          <button
            onClick={handleSubmit}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              padding: "12px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "16px",
              width: "150px",
            }}
          >
            Submit
          </button>

          <button
            onClick={handleSearch}
            style={{
              backgroundColor: "#28a745",
              color: "white",
              padding: "12px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "16px",
              width: "150px",
            }}
          >
            Search
          </button>
          <button
            onClick={regAlive}
            style={{
              backgroundColor: "#28a745",
              color: "white",
              padding: "12px",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "16px",
              width: "170px",
            }}
          >
            RegAlive
          </button>
        </div>
      </div>
    </div>
  );
};

export default Oyreg;
